import { render, staticRenderFns } from "./payment-card.vue?vue&type=template&id=196b22ab&scoped=true&"
import script from "./payment-card.vue?vue&type=script&lang=js&"
export * from "./payment-card.vue?vue&type=script&lang=js&"
import style0 from "./payment-card.vue?vue&type=style&index=0&id=196b22ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b22ab",
  null
  
)

export default component.exports